import * as React from "react";

function SvgAppsFlyer(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 215 215.1"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#1191D0"
        d="M130.9 0c1.4 1.7 3.2 3.2 4.2 5 10.4 19.1 20.7 38.3 31.1 57.4 3.3 6 2.9 11.4-1.5 16.9-12.2 15.4-24.3 30.9-36.4 46.3-.6.7-1.1 1.5-1.8 2.1-2.1 2-4.7 2-6.7-.1-.8-.9-1.5-2-2.1-3-10.5-19.3-21-38.6-31.4-58-3.1-5.7-2.8-11.1 1.3-16.3 12.3-15.4 24.4-31 36.6-46.5 1.1-1.4 2.6-2.5 3.9-3.8h2.8z"
      />
      <path
        fill="#83B441"
        d="M0 63.4c1.3-2.1 3.2-2.8 5.7-2.8 21.3 0 42.5 0 63.8-.1 6.1 0 10.6 2.8 13.5 8.2 10.5 19.7 20.9 39.4 31.3 59.1.3.5.6 1.1.8 1.7 1.5 3.8-.3 6.5-4.4 6.6-6.1.1-12.2.1-18.3.1-15.2 0-30.4 0-45.5.2-6.7 0-11.4-2.9-14.5-8.7C21.7 107.3 11 87.1.3 66.9l-.3-.3v-3.2z"
      />
      <path
        fill="#1191D0"
        d="M113.8 215.1c-.9-1.2-1.9-2.4-2.6-3.7-6-11-11.9-22.1-17.9-33.1-2.1-3.9-1.9-7.3.9-10.8 7.2-9 14.3-18.1 21.4-27.2 2.4-3.1 4.4-3 6.3.5 6.3 11.6 12.6 23.3 18.9 34.9 1.7 3.2 1.6 6.3-.7 9.3-7.3 9.3-14.6 18.6-22 28-.6.8-1.3 1.5-2 2.2-.8-.1-1.6-.1-2.3-.1z"
      />
      <path
        fill="#83B441"
        d="M171.1 179c-6.1 0-12.2-.1-18.2 0-4 .1-6.8-1.7-8.6-5.1l-18.6-34.5c-1.9-3.5-.9-5.2 3.1-5.3 12.1-.1 24.2-.2 36.3-.4 4.4-.1 7.5 1.7 9.5 5.6 6 11.3 12.1 22.5 18.2 33.7.2.3.4.7.5 1 1.4 2.8.4 4.5-2.7 4.6-6.5.1-12.9 0-19.4 0-.1.2-.1.3-.1.4z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAppsFlyer);
